import React from 'react';
import { Button } from '@material-ui/core';
import { AnswerOption } from '../../../../../../types';
import { createEmptyAnswer } from './utils';

interface Props {
  append: (answerOption: AnswerOption) => void;
}

const AddAnswerButton = ({ append }: Props) => (
  <Button
    variant="outlined"
    color="secondary"
    onClick={() => {
      append(createEmptyAnswer());
    }}
  >
    Add answer
  </Button>
);

export default AddAnswerButton;
